import { MyQuotationLine } from '../../models/quotations/MyQuotation';
import { AddToCartProp, CartEdge } from '../../models/Cart';
import {
    QuotationCreateOrderProps,
    QuotationCreateProps,
    QuotationCreateResp,
    SalesQuoteLine,
} from '../../models/quotations/Quotations';
import httpApi from '../api/httpApi';

const useMyQuotations = () => {
    const QUOTATIONS = 'api/v1/quotes';
    const QUOTATIONS_TO_ORDER = 'api/v1/quotes/accept';

    const createPDFQuotation = (quote) => {
        return new Promise(function (resolve, reject) {
            resolve(true);
        });
    };

    const convertProductsToCart = (
        products: MyQuotationLine[]
    ): AddToCartProp[] => {
        return products.map((elem) => {
            return {
                shopify_variant_id: elem.shopify_variant_id,
                quantity: elem.quantity,
                lineType: elem.lineType,
            };
        });
    };

    const convertProductsToQuotation = (
        products: CartEdge[]
    ): SalesQuoteLine[] => {
        return products.map((elem) => {
            return {
                itemCode: elem.node.merchandise.sku,
                quantity: elem.node.quantity,
            };
        });
    };

    const createQuotation = (
        props: QuotationCreateProps
    ): Promise<QuotationCreateResp> => {
        return httpApi
            .post<QuotationCreateResp>(QUOTATIONS, props)
            .then((resp) => {
                return resp.getData();
            });
    };

    const createOrderFromQuotation = (
        props: QuotationCreateOrderProps
    ): Promise<string> => {
        return httpApi.post<string>(QUOTATIONS_TO_ORDER, props).then((resp) => {
            return resp.getData();
        });
    };

    return {
        createPDFQuotation,
        convertProductsToCart,
        createQuotation,
        convertProductsToQuotation,
        createOrderFromQuotation,
    };
};

export default useMyQuotations;
